import React from "react";
import moment from "moment";
import PieChart from "react-minimal-pie-chart";
import "./index.css";

const COLORS = [
  "#E38627",
  "#C13C37",
  "#6A2135",
  "#3c90df",
  "#044792",
  "#82b54b",
  "#00FFFF",
  "#808080",
  "#008080",
  "#808000",
  "#800080",
  "#FF00FF",
];

class CurrentResultModal extends React.Component {
  getChartData = () => {};
  render() {
    const { id, answers, question } = this.props;
    console.log("Answers: ", answers);
    return (
      <div
        className="modal fade poll_result"
        id={`poll_result_modal_${id}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{question}</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="current-date">
              {moment().format("dddd DD/MM/YYYY")}
            </div>
            <div className="result-content">
              <PieChart
                animate={false}
                animationDuration={500}
                animationEasing="ease-out"
                cx={50}
                cy={50}
                data={answers.map((answer, index) => ({
                  color: COLORS[index],
                  title: answer.text,
                  value: answer.count
                }))}
                label={({ data, dataIndex }) =>
                  Math.round(data[dataIndex].percentage) + "%"
                }
                labelPosition={80}
                labelStyle={{
                  fill: "#fff",
                  fontFamily: "sans-serif",
                  fontSize: "5px"
                }}
                lengthAngle={360}
                lineWidth={100}
                onClick={undefined}
                onMouseOut={undefined}
                onMouseOver={undefined}
                paddingAngle={0}
                radius={50}
                rounded={false}
                startAngle={0}
                viewBoxSize={[100, 100]}
              />
              <div className="labels-container">
                {answers.map((answer, index) => (
                  <div className="label" key={index}>
                    <i
                      className="fa fa-circle mr-2 xs-full-width"
                      style={{ color: COLORS[index] }}
                    ></i>
                    {answer.text}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CurrentResultModal;



// WEBPACK FOOTER //
// ./src/screens/Polls/components/CurrentResultModal/index.js